// import {useTestTenantApi} from "@/hooks/useTestTenantApi";
import {ReportRunTimePeriod} from '@/types/ApiTypes';
import {format as formatDate, subDays} from 'date-fns';

export const formatPercent = (num) => {
    if (num === null || num === undefined) {
        return '';
    }
    let str = (num * 100).toFixed(1);
    let newStr = addComma(str.split('.')[0]) + '.' + str.split('.')[1];
    return newStr.includes('.') ? newStr : newStr + '.0';
};
export const formatPrice = (num) => {
    try {
        if (num === null || num === undefined) {
            return '';
        }
        num = parseFloat(num);
        let decimals = num.toString().split('.')[1];
        if (!decimals) return num + '.00';
        else if (decimals.length === 1) return num + '0';
        else return num.toFixed(2);
    } catch (e) {
        // console.log('error formatPrice num=', num, ' err is ', e);
        throw e;
    }
};
export const formatPercentWithSign = (num) => {
    if (num === null || num === undefined) {
        return '';
    }
    let addPositive = '';
    if (num > 0) addPositive = '+';
    let str = addPositive + (num * 100).toFixed(1);
    let newStr = addComma(str.split('.')[0]) + '.' + str.split('.')[1];
    return newStr.includes('.') ? newStr : newStr + '.0';
};
export const toTitleCase = (str) => {
    if (str === null || str === undefined) {
        return '';
    }
    return str.replace(/\w\S*/g, function (txt) {
        if (txt.indexOf('/') > -1) {
            let first = txt.split('/')[0];
            let second = txt.split('/')[1];
            return (
                first.charAt(0).toUpperCase() +
                first.substr(1).toLowerCase() +
                '/' +
                second.charAt(0).toUpperCase() +
                second.substr(1).toLowerCase()
            );
        } else {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    });
};
export const formatDateDDMMYYYY = (str) => {
    if (str === null || str === undefined) {
        return '';
    }

    function pad(s) {
        return s < 10 ? '0' + s : s;
    }

    var d = new Date(str);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
};
export const formatDateMMDDYYYY = (str) => {
    if (str === null || str === undefined) {
        return '';
    }

    function pad(s) {
        return s < 10 ? '0' + s : s;
    }

    const d = new Date(str);
    return [pad(d.getMonth() + 1), pad(d.getDate()), d.getFullYear()].join('/');
};
export const numberWithCommas = (num) => {
    if (num > 999 && num < 1000000) {
        return addComma((num / 1000).toFixed(0)) + 'K'; // convert to K for number from > 1000 < 1 million
    } else if (num > 1000000) {
        return addComma((num / 1000000).toFixed(0)) + 'M'; // convert to M for number from > 1 million
    } else {
        return num;
    }
};

export const generateTable = (arr, config = {
    percentKeys: [] as any,
    titleCaseColumns: [] as any,
    dollarColumns: [] as any,
    columnMapping: {},
    defaultValue: {},
}) => {
    //console.log('config ', config)
    let htmlStr = '<table border="1" style="border-collapse: collapse;padding:1em;">';
    htmlStr += '<tr>';
    Object.keys(config.columnMapping).forEach((key) => {
        htmlStr += `<th style='padding:0.8em'>${config.columnMapping[key]}</th>`;
    });
    htmlStr += `</tr>`;
    let style = `style="text-align: center;padding:0.8em"`;
    arr.forEach((item) => {
        htmlStr += '<tr>';
        Object.keys(config.columnMapping).forEach((key) => {
            if (item[key] === null && config.defaultValue[key]) {
                htmlStr += `<td ${style}> ${config.defaultValue[key]}</td>`;
                return;
            }
            if (config.percentKeys.includes(key) && typeof item[key] === 'number') {
                let val = formatPercent(item[key]);
                htmlStr += `<td ${style}> ${val}%</td>`;
            } else if (config.titleCaseColumns.includes(key)) htmlStr += `<td ${style}> ${toTitleCase(item[key])}</td>`;
            else if (config.dollarColumns.includes(key) && typeof item[key] === 'number')
                htmlStr += `<td ${style}> $${formatPrice(item[key])}</td>`;
            else htmlStr += `<td ${style}> ${item[key]}</td>`;
        });
        htmlStr += '</tr>';
    });
    htmlStr += '</table>';
    return htmlStr;
};
export const generateOrderedList = (arr, olType, value) => {
    //console.log('array', arr);
    let htmlStr = '<ol style="margin-left:2em">';
    if (olType === 'growing_market') {
        arr.forEach((item) => {
            htmlStr += `<li>${toTitleCase(item.market)} (${formatPercent(item.of_category)}% of total US FMCG, `;
            if (!item.retailer_growth) htmlStr += `New market) </li>`;
            else if (item.retailer_growth <= -100) htmlStr += `Delisted) </li>`;
            if (value === 'pos') {
                htmlStr += `sales are ${returnColorSpan(
                    `${formatPercentWithSign(item.retailer_growth)}%`,
                    `#0fbc61`
                )} ) </li>`; // green
            } else if (value === 'neg') {
                htmlStr += `sales are ${returnColorSpan(
                    `${formatPercentWithSign(item.retailer_growth)}%`,
                    `#ff7b4d`
                )} ) </li>`; // orange
            }
            // else htmlStr += `sales are ${txtColor(`${formatPercentWithSign(item.retailer_growth)}%`, item.retailer_growth)} ) </li>`;
        });
    } else if (olType === 'top_market_sales') {
        arr.forEach((item) => {
            htmlStr += `<li>${toTitleCase(item.market)} (${formatPercent(
                item.of_sales_from_retailer
            )}% of total US FMCG, `;
            if (!item.change_of_sales_from_retailer) htmlStr += ` New market)</li>`;
            else if (item.change_of_sales_from_retailer <= -100) htmlStr += ` Delisted)</li>`;
            else
                htmlStr += `sales are ${txtColor(
                    `${formatPercentWithSign(item.change_of_sales_from_retailer)}%`,
                    item.change_of_sales_from_retailer
                )}) </li>`;
            // console.log('item.change_of_sales_from_retailer ', item.change_of_sales_from_retailer);
        });
    } else if (olType === 'largest_brand_sales') {
        arr.forEach((item) => {
            htmlStr += `<li>${toTitleCase(item.brand)} (${formatPercent(item.of_sales_from_brand)}% of category, `;
            if (!item.change) htmlStr += ` New market)</li>`;
            else if (item.change <= -100) htmlStr += ` Delisted)</li>`;
            else htmlStr += `sales are ${txtColor(`${formatPercentWithSign(item.change)}%`, item.change)}) </li>`;
            // console.log('item.change ', item.change);
        });
    }
    htmlStr += '</ol>';
    //console.log('ordered list bef', htmlStr);
    htmlStr = htmlStr.replace(/Fmcg/g, 'FMCG');
    //console.log('ordered list after', htmlStr);

    return htmlStr;
};
export const generateOrderedListWithBrandAndGrowth = (arr) => {
    //console.log('array', arr);
    let htmlStr = '<ol style="margin-left:2em">';
    arr.forEach((item) => {
        htmlStr += `<li>${toTitleCase(item.brand)} (sales are ${numberWithCommas(item.total_dollars)}, `;
        htmlStr += item.brand_growth
            ? `${returnColorSpan(`${item.brand_growth}%`, `#0fbc61`)}) </li>`
            : `New brand)</li>`;
    });
    htmlStr += '</ol>';
    return htmlStr;
};
export const generateBasicOrderedList = (arr) => {
    //console.log('array', arr);
    let htmlStr = '<ol style="margin-left:2em">';
    arr.forEach((item) => {
        htmlStr += `<li>${toTitleCase(item)} </li>`;
    });
    htmlStr += '</ol>';
    //console.log("ordered list", htmlStr);
    return htmlStr;
};
export const addComma = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export const textBold = (str) => {
    return str.bold();
};

// ---------------------------------color and formatting changes ------------------------------

export const getDirection = (num, positive, negative, flat) => {
    if (num >= 0.0005) {
        return positive;
    } else if (num < 0.0005 && num > -0.0005) return flat;
    else if (num <= -0.0005) return negative;
    else if (num <= -1) return 'Delisted';
    else return;
};

export const returnNewtext = (txt, newtxt) => {
    // if (${ formatPercent(alertResults.share_of_category_change) })
    // return `<span></>`
};

export const returnColorSpan = (txt, color) => {
    return `<span style="color: ${color}">${txt}</span>`;
};

export const promoEffColor = (txt, value) => {
    if (value >= 2) return `<span style="color: #0fbc61">${txt}</span>`;
    else if (value < 2 && value >= 1) return `<span style="color: #ff7b4d">${txt}</span>`;
    else if (value < 1) return `<span style="color: #ffbf3f">${txt}</span>`;
};

// text is raw html, value decides the color
export const txtColor = (txt, direction, reverse = false) => {
    let classState = '';

    if (
        direction === 'up' ||
        direction === 'increased' ||
        direction === 'over' ||
        direction === 'gained' ||
        direction === 'gain' ||
        direction === 'grew' ||
        direction >= 0.0005
    ) {
        classState = reverse ? 'negative-value' : 'positive-value';
        // console.log('classatte in reverse is ---> ', classState);
    } else if (
        direction === 'down' ||
        direction === 'decreased' ||
        direction === 'under' ||
        direction === 'lost' ||
        direction === 'decline' ||
        direction === 'declined' ||
        direction <= -0.0005
    ) {
        classState = reverse ? 'positive-value' : 'negative-value';
        // console.log('classatte in reverse is ---> ', classState);
    } else {
        classState = 'flat-value';
        // console.log('classatte in reverse is ---> ', classState);
    }

    let htmlStr = `<span class=${classState}>${txt}</span>`;
    return htmlStr;
};

export function toRunsText(runCount) {
    if (runCount === 0) {
        return 'no ';
    } else if (runCount === Infinity) {
        return 'unlimited ';
    } else {
        return runCount + ' ' ?? ' (calculating ...) ';
    }
}

export function convertSnakeCaseToProperCase(snakeCaseString) {
    if (!snakeCaseString || typeof snakeCaseString !== 'string') {
        return undefined;
    }
    const properCaseString = snakeCaseString?.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase());
    return properCaseString;
}

export function reportRunTimePeriodToString(timePeriod: ReportRunTimePeriod): string | undefined {
    if (!timePeriod) {
        return undefined;
    }

    const periodWeeks = timePeriod.period?.match(/\d+/) ?? [];

    if ((periodWeeks?.[0] || timePeriod.weeks) && timePeriod.end) {
        return `${periodWeeks?.[0] ?? timePeriod.weeks} Weeks Ending ${formatDate(subDays(new Date(timePeriod.end!), 1), 'M/d/yyyy')}`; //BYZ-8923; subtract a day in the fe because in the backend the enddate is always range+1 day,exclusive
    }

    if ((timePeriod?.omniTimePeriod)?.toUpperCase() === 'CUSTOM TIME PERIOD') {
        return `${timePeriod.months} Months Ending ${formatDate(new Date(timePeriod.start!), 'M/d/yyyy')}`;
    }

    if (timePeriod?.months && timePeriod.start && timePeriod.end) {
        return `${timePeriod.months} Months Ending ${formatDate(new Date(timePeriod.end!), 'M/d/yyyy')}`;
    }

    if (timePeriod.period) {
        return timePeriod.period;
    }

    if (timePeriod.omniTimePeriod) {
        return timePeriod.omniTimePeriod;
    }

    if (timePeriod.cpsTimePeriod) {
        return timePeriod.cpsTimePeriod;
    }

    return undefined;
}

export function shortNumber(value: number = 0): string | number {

    value = Math.round(value);

    if (value < 1000) {
        return value;
    } else if (value < 1000000) {
        return `${(value / 1000).toFixed(1)}K`;
    }

    return `${(value / 1000000).toFixed(1)}M`;
}

